function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var FatalError = function(_param) {
    var width = _param.width, height = _param.height, title = _param.title, rest = _objectWithoutProperties(_param, [
        "width",
        "height",
        "title"
    ]);
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", _objectSpread({}, rest, {
        width: width,
        height: height,
        viewBox: "0 0 437 392",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "0%",
                        x2: "100%",
                        y2: "100%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-1"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "-30.9623184%",
                        y1: "0%",
                        x2: "100%",
                        y2: "67.5283041%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-4"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#B4EC51"
                            }),
                            _jsx("stop", {
                                offset: "52.4752468%",
                                stopColor: "#53A0FD"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#3023AE"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "0%",
                        x2: "100%",
                        y2: "100%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-7"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "24.2543784%",
                        y1: "-8.05028967%",
                        x2: "99.7549977%",
                        y2: "142.27058%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-10"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#C86DD7"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#3023AE"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "10.2243802%",
                        y1: "-41.6999317%",
                        x2: "44.3159645%",
                        y2: "84.1884652%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-13"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#3023AE"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#C86DD7"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "16.1668724%",
                        y1: "3.90448068%",
                        x2: "76.2897932%",
                        y2: "75.31854%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-16"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#C86DD7"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#3023AE"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "0%",
                        x2: "50%",
                        y2: "74.4382679%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-20"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "26.2596298%",
                        x2: "73.3674654%",
                        y2: "60.1403897%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-23"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "97.6810874%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.4"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "3.0565022%",
                        y1: "3.81578571%",
                        x2: "3.0565022%",
                        y2: "100%",
                        id: "".concat(uniqueID, "FatalError-linearGradient-24"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#E1E1E1"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-2"),
                        points: "44.9900248 145.49618 30.1831695 78.9171998 96.7623134 94.0119191"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-5"),
                        points: "19.2053904 226.760426 9.33415351 182.374438 53.7202495 192.437585"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-8"),
                        points: "143.890923 234.161356 134.019686 189.775368 178.405782 199.838515"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-11"),
                        points: "76.5913862 255.979198 37.0646789 79.9145727 212.697413 121.906152"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-14"),
                        points: "54.1017213 152.109457 26.011093 26.6872327 151.434522 55.3199434"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-17"),
                        points: "2.4957063 167.602858 -21.4348368 61.7495643 84.161345 87.1610532"
                    }),
                    _jsx("polygon", {
                        id: "".concat(uniqueID, "FatalError-path-25"),
                        points: "171.460976 179.521977 143.370347 54.099753 268.793776 82.7324636"
                    }),
                    _jsxs("filter", {
                        x: "-57.8%",
                        y: "-38.3%",
                        width: "215.7%",
                        height: "217.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-3"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "14",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "10.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "6",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-57.5%",
                        y: "-39.4%",
                        width: "214.9%",
                        height: "217.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-6"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "9",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "1",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "7",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "3.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.149019608 0 0 0 0 0.617026601 0 0 0 0 0.949019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.415686275 0 0 0 0 0.882352941 0 0 0 0.610768138 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-57.5%",
                        y: "-39.4%",
                        width: "214.9%",
                        height: "217.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-9"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "9",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "1",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "7",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "3.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-51.5%",
                        y: "-35.5%",
                        width: "203.1%",
                        height: "206.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-12"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "24.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.517647059 0 0 0 0 0.341176471 0 0 0 0 0.850980392 0 0 0 1 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-51.2%",
                        y: "-34.0%",
                        width: "202.3%",
                        height: "204.9%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-18"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.0061692",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-75.3%",
                        y: "-58.1%",
                        width: "250.6%",
                        height: "253.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-19"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "21",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "15",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "8",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-44.2%",
                        y: "-38.7%",
                        width: "236.7%",
                        height: "253.4%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "FatalError-filter-26"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "0.741311963",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "30",
                                dy: "58",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "18.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feComposite", {
                                in: "shadowBlurOuter1",
                                in2: "SourceAlpha",
                                operator: "out",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "FatalError-path-21"),
                        x: "0",
                        y: "0",
                        width: "22.355032",
                        height: "21.6699229"
                    })
                ]
            }),
            _jsx("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: _jsx("g", {
                    id: "".concat(uniqueID, "FatalError-Hero/Error/Fatal-Error"),
                    transform: "translate(54.000000, -23.000000)",
                    children: _jsxs("g", {
                        transform: "translate(39.000000, 29.000000)",
                        children: [
                            _jsx("polygon", {
                                id: "".concat(uniqueID, "FatalError-Path-Copy-2"),
                                stroke: "#E1E1E1",
                                transform: "translate(167.297354, 161.348444) rotate(45.000000) translate(-167.297354, -161.348444) ",
                                points: "119.007694 249.380757 79.4809868 73.3161308 255.11372 115.30771",
                                strokeWidth: "0.80061692"
                            }),
                            _jsx("polygon", {
                                id: "".concat(uniqueID, "FatalError-Path-Copy-3"),
                                stroke: "#E1E1E1",
                                transform: "translate(124.420639, 124.343794) rotate(45.000000) translate(-124.420639, -124.343794) ",
                                points: "76.1309792 212.376107 36.6042719 36.311481 212.237006 78.3030599",
                                strokeWidth: "0.80061692"
                            }),
                            _jsx("polygon", {
                                id: "".concat(uniqueID, "FatalError-Path-Copy-4"),
                                stroke: "#E1E1E1",
                                transform: "translate(124.420639, 192.432350) rotate(45.000000) translate(-124.420639, -192.432350) ",
                                points: "76.1309792 280.464662 36.6042719 104.400037 212.237006 146.391616",
                                strokeWidth: "0.80061692"
                            }),
                            _jsx("polygon", {
                                id: "".concat(uniqueID, "FatalError-Path-Copy"),
                                stroke: "url(#".concat(uniqueID, "FatalError-linearGradient-13)"),
                                transform: "translate(124.881046, 167.946886) rotate(45.000000) translate(-124.881046, -167.946886) ",
                                points: "76.5913862 255.979198 37.0646789 79.9145727 212.697413 121.906152",
                                strokeWidth: "2.96524785"
                            }),
                            _jsx("polygon", {
                                id: "".concat(uniqueID, "FatalError-Mask"),
                                stroke: "url(#".concat(uniqueID, "FatalError-linearGradient-20)"),
                                transform: "translate(205.591151, 116.810865) rotate(45.000000) translate(-205.591151, -116.810865) ",
                                points: "170.970065 179.521977 142.879437 54.099753 268.302865 82.7324636",
                                strokeWidth: "0.986359964"
                            }),
                            _jsxs("g", {
                                transform: "translate(63.472741, 112.206690) rotate(45.000000) translate(-63.472741, -112.206690) ",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-3)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-2")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "FatalError-linearGradient-1)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-2")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(31.527201, 204.567432) rotate(45.000000) translate(-31.527201, -204.567432) ",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-6)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-5")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "FatalError-linearGradient-4)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-5")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(156.212734, 211.968362) rotate(45.000000) translate(-156.212734, -211.968362) ",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-9)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-8")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "FatalError-linearGradient-7)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-8")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(124.881046, 167.946886) rotate(45.000000) translate(-124.881046, -167.946886) ",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-12)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-11")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "FatalError-linearGradient-10)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-11")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(116.965370, 26.643348)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "FatalError-mask-15"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "FatalError-path-14")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        transform: "translate(88.722807, 89.398345) rotate(45.000000) translate(-88.722807, -89.398345) ",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-14")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-18)"),
                                        mask: "url(#".concat(uniqueID, "FatalError-mask-15)"),
                                        transform: "translate(31.363254, 114.676211) rotate(45.000000) translate(-31.363254, -114.676211) ",
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "FatalError-filter-19)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "FatalError-path-17")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "FatalError-linearGradient-16)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "FatalError-path-17")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "FatalError-Bottom/Standing/2"),
                                transform: "translate(203.473292, 255.146783) scale(-1, 1) translate(-203.473292, -255.146783) translate(179.473292, 213.146783)",
                                children: [
                                    _jsx("path", {
                                        d: "M35.1470989,76.2387531 C40.910762,75.2704065 46.5180591,73.9510751 47.0822021,76.2387531 C47.5608689,78.1798133 46.1094904,78.9290789 44.5280345,79.70959 L44.1878161,79.8777664 C44.0173674,79.9625394 43.8469013,80.048674 43.6786319,80.1376744 C42.4446557,80.7903439 39.891538,81.7227194 36.0192786,82.934801 C32.886225,83.6185777 30.8326118,83.6185777 29.8584392,82.934801 C29.2156032,81.8742306 29.2156032,80.3888664 29.8584392,78.4787083 C31.976755,77.2218702 33.7396416,76.4752185 35.1470989,76.2387531 Z M1.28644645,75.7696607 C3.43654286,74.4778559 5.23457933,73.9224123 6.68055585,74.1033299 C8.28239522,74.3037488 9.69115697,74.3396248 10.9183827,74.3440252 L11.4719464,74.3443057 C14.4461137,74.3388866 16.2619431,74.2625623 17.1082239,76.291956 C17.6678102,77.6338523 16.7228032,78.0832904 15.2144377,78.6585963 C13.7308853,79.2244382 10.8907322,80.0395084 6.69397828,81.1038069 C3.57821421,81.4286614 1.59151177,81.1800892 0.733870975,80.3580905 C0.24349527,79.1882136 0.427687095,77.658737 1.28644645,75.7696607 Z",
                                        fill: "#1F2023"
                                    }),
                                    _jsx("path", {
                                        d: "M30.7213898,-4.26325641e-14 C35.3867706,14.6677181 39.4324856,31.7259921 39.4324856,39.5392099 L39.4324856,39.5392099 L39.4317889,41.911985 C39.4220344,52.7928847 39.2757176,61.2226761 37.0809658,77.1805078 C37.0809658,78.1096321 36.5162341,78.6712384 35.3867706,78.8653268 C33.2883832,79.2259162 31.5843865,79.128872 30.2747808,78.5741942 C27.5468957,59.4222899 28.7401462,52.4808073 24.8110498,40.8092499 C24.5188089,39.9411352 24.2148583,39.1035214 23.9001093,38.2872185 C23.6944335,39.6571099 23.4763928,41.0379493 23.2421365,42.4517343 C21.2538935,54.451187 16.3237196,63.9738699 8.33878178,74.9711266 C7.89778035,75.7239382 6.90794889,76.1906415 5.36928741,76.3712364 C3.50070081,76.5905551 2.08546834,76.4051469 1.12359002,75.8150118 C7.54979598,57.7147646 8.92641218,53.796893 8.92641218,39.5392099 L8.92600025,39.1151818 C8.91557818,33.7906226 8.70790096,30.2152677 8.36104103,26.5162866 L8.3051255,25.9309365 C7.74408227,20.1595219 6.85488425,13.8524663 5.85488934,-4.26325641e-14 L5.85488934,-4.26325641e-14 Z",
                                        fill: "#0071F2"
                                    }),
                                    _jsx("path", {
                                        d: "M8.8888568,-4.26325641e-14 C13.5971652,18.1921101 18.3671587,25.84169 22.0997868,34.0304578 L22.3922927,34.6782616 C22.9177381,35.8535072 23.4214124,37.0457159 23.9001093,38.2872185 C23.6944335,39.6571099 23.4763928,41.0379493 23.2421365,42.4517343 C21.2538935,54.451187 16.3237196,63.9738699 8.33878178,74.9711266 C7.89778035,75.7239382 6.90794889,76.1906415 5.36928741,76.3712364 C3.50070081,76.5905551 2.08546834,76.4051469 1.12359002,75.8150118 C7.54979598,57.7147646 8.92641218,53.796893 8.92641218,39.5392099 L8.92600025,39.1151818 C8.91557818,33.7906226 8.70790096,30.2152677 8.36104103,26.5162866 L8.3051255,25.9309365 C7.74408227,20.1595219 6.85488425,13.8524663 5.85488934,-4.26325641e-14 L5.85488934,-4.26325641e-14 L8.8888568,-4.26325641e-14 Z",
                                        fill: "#000000",
                                        fillOpacity: "0.15"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "FatalError-Body/4"),
                                transform: "translate(204.650903, 197.919529) scale(-1, 1) translate(-204.650903, -197.919529) translate(177.650903, 171.419529)",
                                children: [
                                    _jsx("path", {
                                        d: "M24.0834032,0.691255667 C28.735336,0.691255667 29.406151,0.812793415 30.081888,0.960264711 L30.1952399,0.985066993 C30.6542976,1.08510548 31.2139635,1.19430939 33.0552865,1.28435155 C33.4136668,1.30187663 33.7547867,1.34325284 34.0792129,1.4095458 L34.1309897,1.40174494 L34.1309897,1.40174494 C44.8940616,3.85327133 53.4705597,18.7830602 53.4705597,25.0501446 C53.4705597,31.317229 46.8468151,40.75916 42.9203384,41.9605564 C41.8606644,41.2274018 41.0407281,39.9728864 40.4605295,38.1970101 C43.6770355,32.5810662 45.0935446,28.1987777 44.7100567,25.0501446 C44.4331226,22.7763727 42.7058025,20.1513824 39.5280964,17.1751735 L39.5280302,33.7842912 C39.5280302,45.7899041 43.1949262,46.9208147 34.5879673,49.6877713 C25.9810085,52.454728 6.90624412,55.7129764 8.57432253,46.1176543 C9.49492361,44.3729556 9.99499745,42.1702212 10.2416143,39.7113942 C5.3247011,35.6066063 0.05811986,29.3463226 0.05811986,25.4053892 C0.05811986,19.2298466 8.38589839,4.64281886 18.9274691,1.8723371 C20.4880543,1.11406621 22.2165041,0.691255667 24.0834032,0.691255667 Z M9.9772471,22.2839032 L9.88687648,22.4381831 C9.28801058,23.4860425 8.93192601,24.4751113 8.81862278,25.4053892 C8.6541549,26.7557554 9.15759034,28.373426 10.3289291,30.2584012 C10.2142808,27.5555858 10.0455936,24.8353645 9.9772471,22.2839032 Z",
                                        fill: "#FDF9E7"
                                    }),
                                    _jsx("path", {
                                        d: "M10.032847,17.252147 C9.93071938,18.8052666 9.92955463,20.503541 9.97724946,22.2839912 C9.32330552,23.3894694 8.9374495,24.4297606 8.81862278,25.4053892 C8.65415949,26.7557177 9.1575622,28.3733356 10.3288309,30.2582432 C10.4705781,33.5447199 10.5329463,36.8067462 10.2416143,39.7113942 C5.3247011,35.6066063 0.05811986,29.3463226 0.05811986,25.4053892 C0.05811986,19.229651 8.38642594,4.6418948 18.9284707,1.87207389 C13.7919141,4.3730107 10.4753942,10.52205 10.032847,17.252147 Z",
                                        fill: "#000000",
                                        fillOpacity: "0.15"
                                    }),
                                    _jsx("path", {
                                        d: "M40.6652924,37.997185 C37.8626302,39.4181635 36.4145015,40.2905303 36.4145015,41.8194006 C36.4145015,43.0177418 37.7103157,45.4255793 39.8047139,45.0170827 C41.899112,44.6085861 42.3708617,43.2948258 43.1949262,41.8194006 C42.3334646,39.4910165 41.815063,38.7170411 40.6652924,37.997185 Z",
                                        fill: "#B28B67"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "FatalError-Head/Back/1"),
                                transform: "translate(202.666725, 163.478971) scale(-1, 1) translate(-202.666725, -163.478971) translate(191.166725, 150.978971)",
                                children: [
                                    _jsxs("g", {
                                        children: [
                                            _jsx("mask", {
                                                id: "".concat(uniqueID, "FatalError-mask-22"),
                                                fill: "white",
                                                children: _jsx("use", {
                                                    xlinkHref: "#".concat(uniqueID, "FatalError-path-21")
                                                })
                                            }),
                                            _jsx("g", {}),
                                            _jsx("path", {
                                                d: "M13.3055271,2.37552506 C19.4580816,2.37552506 19.4873642,7.18759741 19.9130691,9.60298851 C20.4536484,12.6701608 19.4873642,17.437863 17.8540165,18.4022967 C16.99159,18.9115289 16.5170358,19.1421006 15.4253949,19.6322966 C13.974199,20.2839489 14.21294,23.499206 14.237105,25.1525118 L14.5485129,27.3538371 L6.03231023,27.3538371 L7.26077776,21.6209047 C7.55106871,20.0974105 8.50902568,16.4909565 7.91723391,15.8562612 C6.17768117,13.9905949 5.35468025,12.7838222 5.35468025,10.6573391 C5.35468025,7.62509719 6.64219453,2.37552506 13.3055271,2.37552506 Z",
                                                fill: "#B28B67",
                                                mask: "url(#".concat(uniqueID, "FatalError-mask-22)")
                                            })
                                        ]
                                    }),
                                    _jsx("path", {
                                        d: "M18.4495778,6.49628191 C10.6319699,8.68013445 21.576017,18.1117999 15.5800028,22.6030183 C9.37650917,27.2496459 2.11819288,22.4576594 1.56687133,19.0665302 C1.01554978,15.6754009 0.101762893,6.9961916 6.90370553,2.46439404 C13.7056482,-2.06740353 22.2045246,4.5479871 18.4495778,6.49628191 Z",
                                        fill: "#3C3226"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(206.082062, 116.810865) rotate(45.000000) translate(-206.082062, -116.810865) ",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "FatalError-filter-26)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-25")
                                    }),
                                    _jsx("use", {
                                        stroke: "url(#".concat(uniqueID, "FatalError-linearGradient-24)"),
                                        fill: "url(#".concat(uniqueID, "FatalError-linearGradient-23)"),
                                        strokeWidth: "1.48262393",
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "FatalError-path-25")
                                    })
                                ]
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "FatalError-Rectangle"),
                                fill: "#FFFFFF",
                                x: "116.728578",
                                y: "102.132833",
                                width: "14.7850741",
                                height: "50.3263237"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "FatalError-Rectangle-Copy-21"),
                                fill: "#FFFFFF",
                                x: "116.480235",
                                y: "158.379901",
                                width: "14.7850741",
                                height: "14.8018599",
                                rx: "7.39253704"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
FatalError.defaultProps = {
    height: 400,
    width: 400
};
FatalError.isCarinaIllustration = true;
export default FatalError;
